// extracted by mini-css-extract-plugin
export default {"actionDiv":"divs-module___actionDiv___df906fff","clickable":"divs-module___clickable___bba4abad","flex":"divs-module___flex___d122362b","center":"divs-module___center___cfde6354"};